import { Component, type ReactNode } from "react";

type AskReliFloatingErrorBoundaryProps = {
  resetKey: string;
  children: ReactNode;
  fallback: (onRetry: () => void) => ReactNode;
};

type AskReliFloatingErrorBoundarySnapshot = {
  error: Error | null;
};

export class AskReliFloatingErrorBoundary extends Component<
  AskReliFloatingErrorBoundaryProps,
  AskReliFloatingErrorBoundarySnapshot
> {
  state: AskReliFloatingErrorBoundarySnapshot = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidUpdate(previousProps: AskReliFloatingErrorBoundaryProps) {
    if (
      previousProps.resetKey !== this.props.resetKey &&
      this.state.error !== null
    ) {
      this.setState({ error: null });
    }
  }

  retry = () => {
    this.setState({ error: null });
  };

  render() {
    if (this.state.error) {
      return this.props.fallback(this.retry);
    }

    return this.props.children;
  }
}
